import { createSlice }          from '@reduxjs/toolkit';
import NotificationService      from 'services/notification.service';
import AuthService              from 'services/auth.service';

export const notificationSlice = createSlice({
  name: 'theNotification',
  initialState: {
    loading: false,
    notifications: [],
    hasErrors: '',
    meta: {},
    page: 0
  },
  reducers: {
    updatePage: (state, action) => {
      state.page = action.payload;
    },
    getNotifications: state => {
      state.loading = true
    },
    getNotificationsSuccess: (state, {payload}) => {
      state.notifications = payload.notifications
      state.meta = payload.meta
      state.loading = false
    },
    getNotificationsFailure: state => {
      state.loading = false
      // has errors
    },
  },
})

// Action creators are generated for each case reducer function
export const { updatePage, getNotifications, getNotificationsSuccess, getNotificationsFailure } = notificationSlice.actions
export const notificationsSelector = state => state.theNotification

export default notificationSlice.reducer

// Asynchronous thunk action
export function fetchNotifications(page) {
  return async dispatch => {
    const practiceLocation = AuthService.getPracticeLocation();
    const socketInfo = AuthService.getSocketInfo();
    const currentUser = AuthService.getCurrentUser();
    dispatch(updatePage(page))
    dispatch(getNotifications())

    const params = {
      page: page,
      location_id: practiceLocation?.id,
      sort_by: 'newest'
    }

    if(socketInfo.isAssistant){
      params['doctor_id'] = currentUser.id;
    }
    NotificationService.notifications(params).then(
      (data) => {
        dispatch(getNotificationsSuccess(data))
      },
      (error) => {
        dispatch(getNotificationsFailure())
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/eb/login');
        }
      }
    );
  }
}